
import { defineComponent, ref } from "vue";
import { shopgtList, updateListFiled, addShopgt, shopgtUpdate } from "@/api/Brand";
import { ElMessage, FormInstance } from "element-plus";
import moment from "moment";

export default defineComponent({
  name: "Commodityclass",
  setup() {
    const tabsType = (type: string | number) => {
      console.log(type);
    };
    const btnLoading = ref(false);
    const ruleFormRef = ref<FormInstance>();

    const modelrules = ref({
      typeName: [
        { required: true, message: "请输入分类名称（限制6字内）", trigger: "blur" },
        { min: 1, max: 6, message: "长度限6字内", trigger: "blur" },
      ],
      img: [{ required: true, message: "请上传分类图片", trigger: "change" }],
    });
    const DialogTitle = ref<string>("");
    // from 开关
    const FromDisplay = ref<boolean>(false);
    const FromData = ref();
    //
    const myclick = (row: any) => {
      console.log(row);
      // if (levelNum.value != 3) {
      levelUpparentId.value = row.parentid;
      // }

      // imageUrl.value = row.img;
      FromData.value = {
        parentid: row.parentId,
        typeName: row.typeName,
        img: row.img,
        id: row.id,
        level: row.level,
      };
      FromDisplay.value = true;
      DialogTitle.value = "编辑分类";
    };
    // 添加分类
    const addClass = () => {
      FromData.value = {
        parentid: !leveltypeName.value ? "当前分类层级为一级，无上级分类" : leveltypeName.value,
      };
      FromDisplay.value = true;
      DialogTitle.value = "新增分类";
    };
    const submitForm = async (formEl: FormInstance | undefined) => {
      console.log(formEl);

      if (!formEl) return;
      await formEl.validate((valid: any, fields: any) => {
        if (valid) {
          btnLoading.value = true;
          if (DialogTitle.value == "新增分类") {
            let params = {
              typeName: FromData.value.typeName,
              img: FromData.value.img,
              level: levelNum.value,
              parentid: levelNum.value == 1 ? "" : levelUpparentId.value,
            };
            addShopgt(params)
              .then((res) => {
                if (res.code === 1) {
                  console.log(res);
                  ElMessage({
                    message: "操作成功",
                    type: "success",
                  });
                }
                getTable();
                FromDisplay.value = false;
                btnLoading.value = false;
              })
              .catch(() => {
                btnLoading.value = false;
              });
          } else if (DialogTitle.value == "新增下级分类") {
            addShopgt(FromData.value)
              .then((res) => {
                if (res.code === 1) {
                  console.log(res);
                  ElMessage({
                    message: "操作成功",
                    type: "success",
                  });
                }
                getTable();
                FromDisplay.value = false;
                btnLoading.value = false;
              })
              .catch(() => {
                btnLoading.value = false;
              });
          } else {
            if (levelNum.value == 1) {
              FromData.value.parentid = 0;
            }
            shopgtUpdate(FromData.value)
              .then((res) => {
                if (res.code === 1) {
                  console.log(res);
                  ElMessage({
                    message: "操作成功",
                    type: "success",
                  });
                }
                FromDisplay.value = false;
                btnLoading.value = false;
                baseRequest.value.parentId = levelparentId.value;
                if (levelNum.value == 1) {
                  delete baseRequest.value.parentId;
                } else if (levelNum.value == 3) {
                  baseRequest.value.parentId = FromData.value.parentid;
                }
                getTable();
              })
              .catch(() => {
                btnLoading.value = false;
              });
          }
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    // 新增下级分类
    const addDownClass = (row: any) => {
      FromDisplay.value = true;

      FromData.value = {
        parentid: row.id,
        img: "",
        level: 0,
      };
      if (row.level == 1) {
        FromData.value.level = 2;
      } else if (row.level == 2) {
        FromData.value.level = 3;
      }
      // FromData.value.name = "";
      // FromData.value.parentid = row.id;
      levelNum.value = row.level;
      levelUpparentId.value = row.id;
      DialogTitle.value = "新增下级分类";
    };
    const isPush = ref();
    const rowId = ref();
    // 推送开关
    const pushDisplay = ref<boolean>(false);
    const switchFn = (row: any) => {
      isPush.value = row.pushStatus;
      pushDisplay.value = true;
      rowId.value = row.id;
    };
    // 表格数据
    const tableData = ref<any>([]);
    const tableColumn = ref([
      {
        prop: "typeName",
        label: "分类名称",
      },
      {
        slotName: "level",
      },
      {
        slotName: "classImg",
      },
      {
        prop: "createTime",
        label: "添加时间",
      },
      {
        slotName: "accounttype",
      },
      {
        slotName: "setUp",
      },
      {
        slotName: "slotName",
      },
    ]);
    const imgViewerVisible = ref(false);
    // 图片预览
    const imgurl = ref<string>("");
    const changeImg = (url: string) => {
      imgurl.value = url;
      imgViewerVisible.value = true;
    };
    const imageUrl = ref("");
    const isLoading = ref(false);
    const levelUpparentId = ref<any>();
    const levelUptypeName = ref<any>("");
    const baseRequest = ref<any>({
      pageNum: 1,
      pageSize: 10,
      level: 1,
      parentId: levelUpparentId.value,
    });
    // 保存当前分类登记
    // 保存父节点
    const levelNum = ref<any>(1);
    const levelparentId = ref<any>();
    const leveltypeName = ref<any>();
    const threeLevelparentId = ref<any>();
    const handleCurrentChange = (val: any) => {
      baseRequest.value.pageNum = val;
      isLoading.value = true;
      getTable();
    };
    const getTable = () => {
      console.log(baseRequest.value, "1111111111111111111");
      shopgtList(baseRequest.value).then((res) => {
        if (res.code === 1) {
          tableData.value = res.data;
          tableData.value.list.forEach((item: any) => {
            item.createTime = item.createTime ? moment(item.createTime).format("YYYY-MM-DD HH:mm:ss") : "--";
          });
          isLoading.value = false;
        }
      });
    };
    getTable();
    const handleSizeChange = (num: any) => {
      baseRequest.value.pageSize = num;
      getTable();
    };
    const handleClose = () => {
      btnLoading.value = false;
      handleCurrentChange(baseRequest.value.pageNum);
    };
    const isPushSuccess = () => {
      console.log(rowId.value);
      let params = {
        type: "02",
        typeId: rowId.value,
      };
      updateListFiled(params).then((res) => {
        if (res.code == 1) {
          ElMessage({
            message: (res.msg as string) || "操作成功",
            type: "success",
          });
        }
        pushDisplay.value = false;
      });
    };
    const uploadChangeImg = (val: any) => {
      console.log(val);
      FromData.value.img = val.fileUrl;
    };

    // 查看下级
    const seeClass = (row: any) => {
      console.log(row);
      levelUpparentId.value = row.id;

      if (row.level == 1) {
        levelNum.value = 2;
        levelparentId.value = row.id;
        leveltypeName.value = row.typeName;
      } else if (row.level == 2) {
        levelNum.value = 3;
        levelUpparentId.value = row.id;
        levelUptypeName.value = ">" + row.typeName;
      }
      console.log(baseRequest.value);

      baseRequest.value.level = levelNum.value;
      baseRequest.value.parentId = row.id;
      if (levelNum.value == 3) {
        baseRequest.value.parentId = levelUpparentId.value;
      }
      getTable();
    };
    // 返回上一层
    const Upclass = () => {
      if (levelNum.value == 2) {
        levelNum.value = 1;
        baseRequest.value.level = 1;
        baseRequest.value.parentId = "";
        levelUptypeName.value = "";
        leveltypeName.value = "";
      } else if (levelNum.value == 3) {
        levelNum.value = 2;
        baseRequest.value.level = 2;
        levelUptypeName.value = "";
        baseRequest.value.parentId = levelparentId.value;
      }
      getTable();
    };
    const delectImg = (val: string) => {
      console.log(123);

      FromData.value.img = val;
    };
    return {
      tabsType,
      tableData,
      leveltypeName,
      tableColumn,
      myclick,
      changeImg,
      levelparentId,
      imgurl,
      imgViewerVisible,
      FromDisplay,
      imageUrl,
      addClass,
      FromData,
      pushDisplay,
      switchFn,
      addDownClass,
      btnLoading,
      DialogTitle,
      isPush,
      isLoading,
      modelrules,
      ruleFormRef,
      handleClose,
      handleSizeChange,
      handleCurrentChange,
      isPushSuccess,
      submitForm,
      uploadChangeImg,
      seeClass,
      levelNum,
      Upclass,
      baseRequest,
      levelUpparentId,
      levelUptypeName,
      delectImg,
    };
  },
});
